import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadDocumentsStep = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.6 0) scale(1.6)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M11.68 6.67375V4.204C11.68 3.08249 11.68 2.52174 11.4617 2.09338C11.2698 1.71659 10.9634 1.41025 10.5866 1.21826C10.1583 1 9.59751 1 8.476 1H4.204C3.08249 1 2.52174 1 2.09338 1.21826C1.71659 1.41025 1.41025 1.71659 1.21826 2.09338C1 2.52174 1 3.08249 1 4.204V11.146C1 12.2675 1 12.8283 1.21826 13.2566C1.41025 13.6334 1.71659 13.9398 2.09338 14.1317C2.52174 14.35 3.08249 14.35 4.204 14.35H6.34M7.675 7.0075H3.67M5.005 9.6775H3.67M9.01 4.3375H3.67M10.345 13.6825V9.6775M8.3425 11.68H12.3475",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgUploadDocumentsStep);
export default ForwardRef;
